import * as React from "react";
const SvgArrowRight = (props) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M14 19L20 13M20 13L14 7M20 13L5 13", stroke: "currentColor", strokeWidth: 1.5, strokeLinejoin: "round" }));
export default SvgArrowRight;
